import {observer} from "mobx-react-lite";
import React from "react";
import {IconSource} from "../../../shared/enums/iconSource";
import ButtonIcon from "../../atoms/button/buttonIcon";
import EditField from "../../molecules/editField/editField";
import "./buttonSelector.scss";

export interface IButtonSelectorProps {
  value?: string;
  label: string;
  buttonText: string;
  onClick?: () => void;
  validationMessage?: string;
  isDisabled?: boolean;
}

const ButtonSelector: React.FC<IButtonSelectorProps> = ({
  value,
  label,
  buttonText,
  onClick,
  validationMessage,
  isDisabled
}) => {
  return (
    <EditField
      label={label}
      showValidationMessage={!value}
      validationMessage={validationMessage}
      isRequired={false}
    >
      <div className="d-flex align-items-center">
        <span className="selected-value mr-3">{value}</span>
        <ButtonIcon
          type="secondary"
          icon={IconSource.replace}
          isDisabled={isDisabled}
          onClick={onClick}
        >
          {buttonText}
        </ButtonIcon>
      </div>
    </EditField>
  );
};

export default observer(ButtonSelector);
